"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _ButtonDraggable = _interopRequireDefault(require("../NavToolbar/ButtonDraggable"));

var _NavToolbar = _interopRequireDefault(require("../NavToolbar/NavToolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiInputBase-root": {
      fontFamily: "Akkurat, sans-serif",
      lineHeight: "1.25",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0"
    },
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    }
  },
  startAdornment: {},
  endAdornment: {},
  iconPrefix: {
    marginTop: theme.spacing(-1.5),
    marginRight: theme.spacing(.5)
  },
  textPrefix: {
    fontSize: "14px",
    color: theme.palette.text.secondary
  },
  buttonPrefix: {
    marginLeft: theme.spacing(-1.5),
    marginTop: theme.spacing(-1.5),
    marginRight: theme.spacing(-1)
  },
  iconPrefixLabel: {
    marginLeft: theme.spacing(4.5)
  }
}));

const InputBase = (_ref) => {
  let _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? undefined : _ref$icon,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? undefined : _ref$prefix,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? undefined : _ref$id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Label" : _ref$label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? undefined : _ref$value,
      placeholder = _ref.placeholder,
      helperText = _ref.helperText,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? undefined : _ref$language,
      draggable = _ref.draggable,
      draggableHandle = _ref.draggableHandle,
      toolbar = _ref.toolbar,
      startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "icon", "prefix", "type", "id", "label", "value", "placeholder", "helperText", "multiline", "language", "draggable", "draggableHandle", "toolbar", "startAdornment", "endAdornment", "onChange"]);

  const classes = useStyles();
  let iconPrefix, textPrefix;

  if (draggable && draggableHandle) {
    iconPrefix = _react.default.createElement(_ButtonDraggable.default, {
      className: classes.buttonPrefix,
      draggableHandle: draggableHandle
    });
  } else if (icon) {
    iconPrefix = _react.default.createElement(_Icon.default, {
      className: classes.iconPrefix
    }, icon);
  }

  if (prefix) {
    textPrefix = _react.default.createElement("b", {
      className: classes.textPrefix
    }, prefix);
  }

  if (iconPrefix || textPrefix) {
    startAdornment = _react.default.createElement(_InputAdornment.default, {
      position: "start"
    }, iconPrefix, textPrefix);
  }

  if (toolbar) {
    endAdornment = _react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, _react.default.createElement(_NavToolbar.default, {
      toolbar: toolbar
    }));
  }

  const shrinkLabel = () => {
    return placeholder && true || value && true || false;
  };

  return _react.default.createElement(_TextField.default, {
    className: classes.root,
    variant: variant,
    type: type,
    id: id,
    multiline: multiline,
    label: label,
    placeholder: placeholder,
    value: value,
    helperText: helperText,
    fullWidth: true,
    InputLabelProps: {
      className: iconPrefix && classes.iconPrefixLabel,
      shrink: shrinkLabel
    },
    InputProps: {
      startAdornment: startAdornment,
      endAdornment: endAdornment
    },
    inputProps: props,
    onChange: onChange
  });
};

var _default = InputBase;
exports.default = _default;
module.exports = exports.default;